import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { LeaveAccrualHistory } from '../interfaces/leaveAccrual.interface';

// Leave accrual engine endpoints (spec §2.3 / task-5-report "Interfaces Task 6 can consume").
// run/carryForward/undoCarryForward are institution-scoped writes (204 No Content, or a bare-
// string 400 refusal — surface those via the house showApiError pattern, never re-worded).
// history is a single-tuple (user, leave type) read.
export const LeaveAccrualService = {
    run: async (year: number, month: number): Promise<void> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        await axios.post(ENDPOINTS.LEAVE_ACCRUAL.RUN(institutionId, year, month), null, {
            headers: AuthService.getAuthHeader(),
        });
    },

    carryForward: async (closingFiscalYear: number, force = false): Promise<void> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        await axios.post(
            ENDPOINTS.LEAVE_ACCRUAL.CARRY_FORWARD(institutionId, closingFiscalYear, force),
            null,
            { headers: AuthService.getAuthHeader() }
        );
    },

    undoCarryForward: async (closingFiscalYear: number): Promise<void> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        await axios.post(
            ENDPOINTS.LEAVE_ACCRUAL.UNDO_CARRY_FORWARD(institutionId, closingFiscalYear),
            null,
            { headers: AuthService.getAuthHeader() }
        );
    },

    history: async (userId: string, leaveTypeId: string): Promise<LeaveAccrualHistory> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(
            ENDPOINTS.LEAVE_ACCRUAL.HISTORY(institutionId, userId, leaveTypeId),
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },
};
